import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=80430006&scoped=true"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"
import style0 from "./Redirect.vue?vue&type=style&index=0&id=80430006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80430006",
  null
  
)

export default component.exports